import React from 'react';
import styled from 'styled-components';

import { SkeletonBlock } from '@/components/common';
import { CalendarDisplayRange } from '@/store/enums';

interface ICalendarWeekContainerSkeleton {
  columnCount: CalendarDisplayRange;
  columnWidth: number;
}

const CalendarWeekContainerSkeleton = ({
  columnCount,
  columnWidth,
}: ICalendarWeekContainerSkeleton): React.ReactElement => (
  <SkeletonContainer>
    {Array.from({ length: columnCount }).map((_, index) => (
      <SkeletonColumn columnWidth={columnWidth} key={index} />
    ))}
  </SkeletonContainer>
);

export { CalendarWeekContainerSkeleton };

const SkeletonContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  height: 100%;
  width: 100%;
`;

const SkeletonColumn = styled(SkeletonBlock)<Pick<ICalendarWeekContainerSkeleton, 'columnWidth'>>`
  height: 100%;
  flex-grow: 1;
  flex-shrink 0;
  flex-basis: ${props => props.columnWidth}px;
  position: relative;
  border-radius: 20px;
  margin: 0 4px;
`;
